export enum CustomFieldType {
  RichTextEditor = 1,
  Images,
  Videos,
  AudioFile,
  PdfFile,
  DonationLink
}